import changePasswordPrompt from "emun.auth/change-password/change-password-prompt";

export default $parse => ({
  scope: false,
  link(scope, element, attr) {
    const ngModel = {
      open(e) {
        return changePasswordPrompt(attr).then(
          args => $parse(attr.onPasswordChanged)(scope, args),
          args => $parse(attr.onDismissed)(scope, args)
        );
      }
    };

    if (attr.ngModel) {
      $parse(attr.ngModel).assign(scope, ngModel);
    }

    const $targets = attr.changePasswordPromptClickSelector
      ? element.find(attr.changePasswordPromptClickSelector)
      : element;
    $targets.on("click", ngModel.open);
  }
});
